import React, {FC, useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {fetchData, toasterrormsg, useMenuIdPermissions} from '../../../reusable'
import {PageTitle} from '../../../_metronic/layout/core'
import {MixedWidget26} from '../../../_metronic/partials/widgets/mixed/MixedWidget26'
import {CarRentalDetailsHeader} from './CarRentalDetailsHeader'
import Swal from 'sweetalert2'
import {Tr} from '../../../_metronic/i18n/Tr'

const ViewCarsList: FC = () => {
  let t = Tr()
  const { menuId,menuIdDelete , menuIdEdit} = useMenuIdPermissions()

  const location = useLocation()
  const editCarrentalId = (location.state as any)?.carrentalId || ''
  // -------- state start ------------
  const [carRentalDetails, setCarRentalDetails] = useState([])
  const [primLanguage, setPrimLanguage] = useState('')

  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(9)
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [displayCarList, setDisplayCarList] = useState([])
  const [pageNumbersList, setPageNumberList] = useState([1])
  // ----------- state end ------------

  // ----------------------- functions ----------------------------
  // page number generater
  function generatePageNumbers(currentPage: any, totalPages: any, maxPagesToShow: any) {
    const halfMaxPages = Math.floor(maxPagesToShow / 2)
    let startPage = Math.max(1, currentPage - halfMaxPages)
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

    // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1)
    }

    // Generate the list of page numbers
    const pageNumbers = []
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i)
    }

    return pageNumbers
  }
  // on page change function
  const onPageChange = (pageId: any) => {
    if (pageId != page && pageId != 0 && pageId <= totalPage) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = carRentalDetails.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit
        } else {
          tolimi = pageId * limit + limit
        }
      } else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = carRentalDetails.slice(tmp, tolimi)
      setDisplayCarList(tmpdata)
    }
  }

  // ------------------------------------- apis call ------------------------------------
  // hotel Details api call
  const carRentalDetailsApiCall = async () => {
    var param: any = {
      carrentalId: String(editCarrentalId),
    }
    var response: any = await fetchData('vendor/public/carRentalDetail', param)

    if (response.status == '200') {
      var carList = response.data[0]['vehcileDetail']
      setCarRentalDetails(carList)
      setPrimLanguage(response.data[0]['primaryLanguage'])
      var tmp: any = carList.slice(offset, offset + limit)
      setDisplayCarList(tmp)
      var totpag = Math.ceil(carList.length / limit)
      setTotalPage(totpag)
      if (totpag == 1) {
        var mod = carList.length % limit
        if (mod > 0) {
          setTo(mod)
        } else {
          setTo(tmp.length)
        }
      } else {
        var mod = carList.length % limit
        if (mod > 0) {
          setTo(page * limit + mod)
        } else {
          setTo(page * limit)
        }
      }
      var genpag = generatePageNumbers(page, totpag, 6)
      setPageNumberList(genpag)
    } else {
      toasterrormsg(response.message)
    }
  }

  //   delete hotel api call
  const confirmdelete = (vehicleId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          vehicleId: vehicleId,
        }
        var res = await fetchData('vendor/public/deleteVehicle', param)

        if (res.status == '200') {
          carRentalDetailsApiCall()
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }

  useEffect(() => {
    carRentalDetailsApiCall()
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('View Cars')}</PageTitle>
      <ToastContainer />
      <CarRentalDetailsHeader />
      {/* begin::Row */}
      <div className='row g-5 g-xl-8 mt-3'>
        {displayCarList.map((car: any, index: any) => {
          var vehicleName = ''
          if (primLanguage == 'English') {
            vehicleName = car['en_name']
          } else if (primLanguage == 'Russian') {
            vehicleName = car['ru_name']
          } else if (primLanguage == 'Uzbek') {
            vehicleName = car['uz_name']
          }
          return (
            <div className='col-xl-4' key={index}>
              <MixedWidget26
                className='card-xl-stretch mb-5 mb-xl-8'
                color='success'
                vehicleId={car['vehicleId']}
                deleteCar={confirmdelete}
                vehicleName={vehicleName}
                image={
                  car['images'].length != 0
                    ? car['images'][0].thumbPath
                    : '/horse/uztrip/vendor/media/logos/InsayrLogo.png'
                }
                carCategory={car['carCategory'].length != 0 ? car['carCategory'][0]['en_name'] : ''}
                mileage={car['mileage']}
                maxPeople={car['seats']}
                progress='100%'
                showDelete ={menuIdDelete}
                showEdit ={menuIdEdit}
                menuId ={menuId}
              />
            </div>
          )
        })}
      </div>
      {carRentalDetails.length != 0 ? (
        <div className='d-flex flex-stack flex-wrap pt-10'>
          <div className='fs-6 fw-bold text-gray-700'>
            Showing {from} to {to} of {carRentalDetails.length} entries
          </div>
          <ul className='pagination'>
            <li className={`page-item previous ${page > 1 ? '' : 'disabled'}`}>
              <span
                className={`page-link ${page > 1 ? 'cursor-pointer' : 'disabled'}`}
                onClick={() => onPageChange(page - 1)}
              >
                <i className='previous'></i>
              </span>
            </li>
            {pageNumbersList.map((item: any, index: any) => {
              return (
                <li
                  className={`page-item cursor-pointer ${page == item ? 'active' : ''}`}
                  key={index}
                >
                  <span className='page-link' onClick={() => onPageChange(item)}>
                    {item}
                  </span>
                </li>
              )
            })}

            <li className={`page-item next ${page + 1 <= totalPage ? '' : 'disabled'}`}>
              <span
                className={`page-link ${page + 1 <= totalPage ? 'cursor-pointer' : 'disabled'}`}
                onClick={() => (page + 1 <= totalPage ? onPageChange(page + 1) : '')}
              >
                <i className='next'></i>
              </span>
            </li>
          </ul>
        </div>
      ) : (
        ''
      )}
      {/* end::Row */}
    </>
  )
}

export {ViewCarsList}
